import { render } from "./CreateEditInfoItem.vue?vue&type=template&id=55d78b48&scoped=true"
import script from "./CreateEditInfoItem.vue?vue&type=script&lang=js"
export * from "./CreateEditInfoItem.vue?vue&type=script&lang=js"

import "./CreateEditInfoItem.vue?vue&type=style&index=0&id=55d78b48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d78b48"]])

export default __exports__